module.exports = __webpack_public_path__ + "img/9791195224302.303dbf8a.jpg";